<template>
  <section class="employee-ask-question-section half-cut-bg">
      <AskQuestionEmployee></AskQuestionEmployee>
  </section>
</template>

<script>
/* eslint-disable */
import AskQuestionEmployee from '../common/customer-support/AskQuestion.vue'
export default {
  name: 'AskQuestion',
  components: { AskQuestionEmployee },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/employee/AskQuestion.vue